<script>
export default {
    name: "orderChat",
    props: {
        orderId: {
            type: [String, Number],
            default: () => {
                return "";
            },
        },
        height: {
            type: String,
            default: 'calc(100vh - 200px)'
        }
    },
    data() {
        return {
            loading: false,
            messageList: []
        };
    },
    mounted() {
        this.getMessageFn()
    },
    methods: {
        async getMessageFn() {
            this.loading = true
            const url = "/api/v1/manage/order/hitchRide/msg";
            const { data, code } = await this.$axios.get(url, {
                id: this.orderId
            })
            if (code === 1 && data) {
                this.messageList = data.sort((a, b) => {
                    return a.created - b.created
                })
            }
            this.loading = false
        }
    },
};
</script>

<template>
    <div class="iphone-box">
        <div class="message-box scrollBar-custom" :style="{ maxHeight: height }" v-loading="loading">
        <div class="message-list" v-for="(item, index) in messageList" :key="index" :style="{
            flexDirection: item.sendType === 1 ? 'row-reverse' : 'row',
        }">
            <div class="message-info">
                <div :style="{ textAlign: item.sendType === 1 ? 'left' : 'right' }">{{ item.sendType === 1 ?
                    '乘客' : '司机' }}</div>
                <div class="message-content" :style="{ background: item.sendType === 1 ? '#FFFFFF' : '#E3F1FE' }">{{
                    item.msgContent }}
                </div>
                <div :style="{ textAlign: item.sendType === 1 ? 'left' : 'right' }">{{ item.created |
                    filterTime }}</div>
            </div>
            <div class="message-head">
                <img v-if="item.sendType === 2" src="@/assets/img/driver.png" alt="">
                <img v-else src="@/assets/img/customer.png" alt="">
            </div>
        </div>
    </div>
    </div>
</template>

<style scoped lang="less">
.iphone-box{
    width: 375px;
    height: 720px;
    background: url('../../../../assets/img/iphone.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 50px 36px 24px 36px;
    box-sizing: border-box;

}
.message-box {
    height: 100%;
    overflow-y: auto;

    .message-list {
        display: flex;
        justify-content: flex-end;

        .message-info {
            margin-bottom: 16px;
            .message-content {
                max-width: 300px;
                padding: 16px;
                border-radius: 5px;
                margin: 5px 0;
            }
        }

        .message-head {
            width: 50px;
            height: 50px;
            flex-shrink: 0;
            border-radius: 10px;
            overflow: hidden;
            margin-left: 10px;

            img {
                width: 50px;
                height: 50px;
            }
        }
    }
}
</style>